import CryptoJS from 'crypto-js'
import { aesKey, ivKey } from '@base/settings'

const key = CryptoJS.enc.Utf8.parse(aesKey)
const iv = CryptoJS.enc.Utf8.parse(ivKey)

//加密方法
export const Encrypt = (data) => {
  let secret = CryptoJS.enc.Utf8.parse(data)
  let encrypted = CryptoJS.AES.encrypt(secret, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  })
  return encrypted.toString()
}
